import PropTypes from 'prop-types'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { formatRange } from '../utils'

const VIEW_LABELS = [
  { value: 'week',      label: 'Week'    },
  { value: 'fortnight', label: '2 Weeks' },
  { value: 'month',     label: 'Month'   },
]

export default function SchedulingToolbar({
  rangeStart,
  rangeEnd,
  view,
  onViewChange,
  layout,
  onLayoutChange,
  onPrev,
  onNext,
  onToday,
  onAddStaff,
  scheduledCount,
  totalStaffCount,
  onImportTimesheet,
}) {
  const staffSubtitle = totalStaffCount > scheduledCount
    ? `${scheduledCount} of ${totalStaffCount} resources in view`
    : `${scheduledCount} resource${scheduledCount === 1 ? '' : 's'} in view`

  return (
    <div className="scheduling-toolbar d-flex flex-wrap align-items-center gap-2">

      <div className="d-flex align-items-center gap-2 me-2">
        <div
          className="d-flex align-items-center justify-content-center rounded"
          style={{ width: 32, height: 32, background: 'var(--brand-color-1)', color: '#fff', flexShrink: 0 }}
        >
          <CalendarMonthIcon style={{ fontSize: 18 }} />
        </div>
        <div>
          <div className="toolbar-title">Schedule</div>
          <div className="toolbar-subtitle">
            {layout === 'staff' ? staffSubtitle : 'Allocation by project'}
          </div>
        </div>
      </div>

      {/* Layout toggle: By Staff / By Project */}
      <div className="layout-toggle">
        <button
          className={`layout-toggle__btn${layout === 'staff' ? ' active' : ''}`}
          onClick={() => onLayoutChange('staff')}
          type="button"
        >
          <PeopleAltIcon style={{ fontSize: 16 }} />
          By Staff
        </button>
        <button
          className={`layout-toggle__btn${layout === 'project' ? ' active' : ''}`}
          onClick={() => onLayoutChange('project')}
          type="button"
        >
          <FolderSpecialIcon style={{ fontSize: 16 }} />
          By Project
        </button>
      </div>

      <div className="ms-auto d-flex align-items-center gap-2 flex-wrap">

        <button className="secondarybtn-outline btn-ch" onClick={onToday} type="button">
          Today
        </button>

        {/* Week navigator */}
        <div className="date-nav">
          <button className="date-nav__btn" onClick={onPrev} aria-label="Previous period" type="button">
            <ChevronLeftIcon style={{ fontSize: 18 }} />
          </button>
          <span className="date-nav__range">{formatRange(rangeStart, rangeEnd)}</span>
          <button className="date-nav__btn" onClick={onNext} aria-label="Next period" type="button">
            <ChevronRightIcon style={{ fontSize: 18 }} />
          </button>
        </div>

        {/* View switcher: Week / 2 Weeks / Month */}
        <div className="layout-toggle">
          {VIEW_LABELS.map((v) => (
            <button
              key={v.value}
              className={`layout-toggle__btn${view === v.value ? ' active' : ''}`}
              onClick={() => onViewChange(v.value)}
              type="button"
            >
              {v.label}
            </button>
          ))}
        </div>

        <button
          className="secondarybtn-outline btn-ch d-flex align-items-center gap-1"
          onClick={onImportTimesheet}
          type="button"
        >
          <UploadFileIcon style={{ fontSize: 16 }} />
          Import Timesheet
        </button>

        {layout === 'staff' && (
          <button
            className="primarybtn btn-ch d-flex align-items-center gap-1"
            onClick={onAddStaff}
            type="button"
          >
            <PersonAddAlt1Icon style={{ fontSize: 16 }} />
            Add Staff
          </button>
        )}
      </div>
    </div>
  )
}

SchedulingToolbar.propTypes = {
  rangeStart:        PropTypes.instanceOf(Date).isRequired,
  rangeEnd:          PropTypes.instanceOf(Date).isRequired,
  view:              PropTypes.string.isRequired,
  onViewChange:      PropTypes.func.isRequired,
  layout:            PropTypes.string.isRequired,
  onLayoutChange:    PropTypes.func.isRequired,
  onPrev:            PropTypes.func.isRequired,
  onNext:            PropTypes.func.isRequired,
  onToday:           PropTypes.func.isRequired,
  onAddStaff:        PropTypes.func.isRequired,
  scheduledCount:    PropTypes.number.isRequired,
  totalStaffCount:   PropTypes.number,
  onImportTimesheet: PropTypes.func.isRequired,
}
